import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'
import { FieldType } from '@wix/wix-data-schema-types'

export const rangeSlider: DataBindingComponentModel = {
  componentName: 'Element_Name_RangeSlider',
  panel: {
    height: 212,
    title: 'Connect_Panel_Title_RangeSlider',
    helpId: '7fc90193-8063-4da0-bf25-e868846d4d05',
    chooseScreenHelpId: '24ab6613-53b2-4312-808e-5e24fa7fa30d',
    userInputFilterHelpId: '7fc90193-8063-4da0-bf25-e868846d4d05',
  },
  sections: [
    {
      role: 'userInputFilterRangeSliderRole',
      isUserInputFilter: true,
      bindings: [
        {
          prop: 'value',
          supportedFieldTypes: [FieldType.number],
          defaultFieldType: FieldType.number,
          requiresPrimaryConnection: true,
        },
      ],
      manifest: {
        panel: {
          settings: {
            controls: {
              required: {
                hidden: true,
              },
            },
            controlGroups: {
              range: {
                hidden: true,
              },
            },
          },
        },
      },
    },
  ],
  compactErrorPanel: true,
}
